"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Modal = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactTransitionGroup = require("react-transition-group");
var _withContainer = require("../withContainer");
var _Content = require("./Content/Content");
var _Trigger = require("./Trigger/Trigger");
var Modal = function Modal(_ref) {
  var animationDuration = _ref.animationDuration,
    className = _ref.className,
    closeButtonRef = _ref.closeButtonRef,
    content = _ref.content,
    dataAttributes = _ref.dataAttributes,
    isOpen = _ref.isOpen,
    modalRef = _ref.modalRef,
    onClickAway = _ref.onClickAway,
    onClose = _ref.onClose,
    onKeyDown = _ref.onKeyDown,
    onOpen = _ref.onOpen,
    text = _ref.text,
    triggerObject = _ref.triggerObject,
    _ref$animationType = _ref.animationType,
    animationType = _ref$animationType === void 0 ? _withContainer.MODAL_ANIMATION_TYPE.none : _ref$animationType,
    _ref$closeButton = _ref.closeButton,
    closeButton = _ref$closeButton === void 0 ? _withContainer.MODAL_CLOSE_BUTTON.right : _ref$closeButton,
    _ref$role = _ref.role,
    role = _ref$role === void 0 ? 'dialog' : _ref$role,
    _ref$styleType = _ref.styleType,
    styleType = _ref$styleType === void 0 ? _withContainer.MODAL_STYLE_TYPE["default"] : _ref$styleType,
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? _withContainer.MODAL_TYPE["default"] : _ref$type;
  var Trigger = Modal.Trigger,
    Content = Modal.Content;
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(Trigger, {
    onOpen: onOpen,
    triggerObject: triggerObject
  }), /*#__PURE__*/_react["default"].createElement(_reactTransitionGroup.CSSTransition, {
    classNames: {
      exitActive: 'cds-Modal-Animation--Close'
    },
    "in": isOpen,
    mountOnEnter: true,
    timeout: animationDuration,
    unmountOnExit: true
  }, /*#__PURE__*/_react["default"].createElement(Content, {
    animationType: animationType,
    className: className,
    closeButton: closeButton,
    closeButtonRef: closeButtonRef,
    content: content(onClose),
    dataAttributes: dataAttributes,
    modalRef: modalRef,
    onClickAway: onClickAway,
    onClose: onClose,
    onKeyDown: onKeyDown,
    role: role,
    styleType: styleType,
    text: {
      ariaCloseModal: text.ariaCloseModal,
      ariaLabel: text.ariaLabel
    },
    type: type
  })));
};
exports.Modal = Modal;
Modal.Trigger = _Trigger.Trigger;
Modal.Content = _Content.Content;
Modal.config = {
  animationType: _withContainer.MODAL_ANIMATION_TYPE,
  closeButton: _withContainer.MODAL_CLOSE_BUTTON,
  styleType: _withContainer.MODAL_STYLE_TYPE,
  type: _withContainer.MODAL_TYPE
};